var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-list-container" },
    [
      _vm.nbElements === 0
        ? _c(
            "div",
            { staticClass: "fs-2 gray-60", on: { click: _vm.toggleList } },
            [_vm._v("\n        " + _vm._s(_vm.listPlaceholder) + "\n    ")]
          )
        : _vm.nbElements > 1
        ? _c("CompassLink", {
            attrs: {
              type: "secondary",
              label: _vm.nbElements + " " + _vm.listPlaceholder,
              size: "small"
            },
            on: { click: _vm.toggleList }
          })
        : _c(
            "div",
            { staticClass: "flex-level" },
            [
              _c("person-light", {
                attrs: { person: _vm.list[0], label: _vm.personPlaceholder }
              })
            ],
            1
          ),
      _vm._v(" "),
      _vm.displayList
        ? _c(
            "div",
            {
              staticClass:
                "person-list pabsolute zi-1000 top-left well p-0 span_12 shadow b-0 ellipsis top-3 br mt-4 ml-4",
              on: { click: _vm.toggleList, mouseleave: _vm.toggleList }
            },
            [
              _c(
                "ul",
                { staticClass: "person m-0 mxh-200 ovy-auto" },
                _vm._l(_vm.list, function(person) {
                  return _c(
                    "li",
                    {
                      key: person.id,
                      staticClass: "px-3 py-2 cpointer copy-element"
                    },
                    [
                      _c("person-light", {
                        attrs: { person: person, label: _vm.personPlaceholder }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }